import { SVGProps, SVGAttributes } from 'react';

const RiskReviewIcon = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
    const { stroke } = props;

    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_4_177" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="49">
                <rect y="0.5" width="48" height="48" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_4_177)">
                <path d="M40 22.5C39.4333 22.5 38.9583 22.3083 38.575 21.925C38.1917 21.5417 38 21.0667 38 20.5C38 19.9333 38.1917 19.4583 38.575 19.075C38.9583 18.6917 39.4333 18.5 40 18.5C40.5667 18.5 41.0417 18.6917 41.425 19.075C41.8083 19.4583 42 19.9333 42 20.5C42 21.0667 41.8083 21.5417 41.425 21.925C41.0417 22.3083 40.5667 22.5 40 22.5ZM38 16.5V6.5H42V16.5H38ZM18 24.5C15.8 24.5 13.9167 23.7167 12.35 22.15C10.7833 20.5833 10 18.7 10 16.5C10 14.3 10.7833 12.4167 12.35 10.85C13.9167 9.28333 15.8 8.5 18 8.5C20.2 8.5 22.0833 9.28333 23.65 10.85C25.2167 12.4167 26 14.3 26 16.5C26 18.7 25.2167 20.5833 23.65 22.15C22.0833 23.7167 20.2 24.5 18 24.5ZM2 40.5V34.9C2 33.7667 2.29167 32.725 2.875 31.775C3.45833 30.825 4.23333 30.1 5.2 29.6C7.26667 28.5667 9.36667 27.7917 11.5 27.275C13.6333 26.7583 15.8 26.5 18 26.5C20.2 26.5 22.3667 26.7583 24.5 27.275C26.6333 27.7917 28.7333 28.5667 30.8 29.6C31.7667 30.1 32.5417 30.825 33.125 31.775C33.7083 32.725 34 33.7667 34 34.9V40.5H2Z"
                      fill={stroke || "#206FA5"}
                />
            </g>
        </svg>
    );
};


export default RiskReviewIcon;
